angular.module("authoring/template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("authoring/template/tabs/tabset.html",
    "<div>\n" +
    "  <div class=\"tab-nav\">\n" +
    "    <button type=\"button\" class=\"nav-dir\" ng-style=\"tabset.arrayStyle\" ng-disabled=\"!tabset.hasPrev\" ng-click=\"tabset.selectPrev($event)\" aria-hidden=\"true\" aria-labelledby=\"previous-tab-label\">\n" +
    "      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n" +
    "        <title id=\"previous-tab-label\">{{ \"Previous tab\" | translate }}</title>\n" +
    "        <path d=\"M9.5 4l-4 4l4 4\"/>\n" +
    "        <path d=\"M1 8a7 7 0 1 0 14 0a7 7 0 1 0 -14 0\"/>\n" +
    "      </svg>\n" +
    "    </button>\n" +
    "    <div class=\"tab-nav-slider\" ng-class=\"{'left-fade': tabset.hasPrev, 'right-fade': tabset.hasNext}\">\n" +
    "      <ul role=\"tablist\" class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" style=\"transform: translateX({{tabset.offset}}px);\" ng-transclude></ul>\n" +
    "    </div>\n" +
    "    <button type=\"button\" class=\"nav-dir\" ng-style=\"tabset.arrayStyle\" ng-disabled=\"!tabset.hasNext\" ng-click=\"tabset.selectNext($event)\" aria-hidden=\"true\" aria-labelledby=\"next-tab-label\">\n" +
    "      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n" +
    "        <title id=\"next-tab-label\">>{{ \"Next tab\" | translate }}</title>\n" +
    "        <path d=\"M6.5 4l4 4l-4 4\"/>\n" +
    "        <path d=\"M1 8a7 7 0 1 0 14 0a7 7 0 1 0 -14 0\"/>\n" +
    "      </svg>\n" +
    "    </button>\n" +
    "  </div>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         authoring-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);



// WEBPACK FOOTER //
// ./app/common/tabs/template/tabset.html.js